import React, {Component} from 'react';
import Modal from "react-bootstrap/Modal";
import {error} from "../../utils/Toast";

import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'


class UploadImage extends Component {


    constructor(props) {
        super(props);

        this.state = {
            cropModalShow: false,
            src: null,
            crop: this.props.initialWidth || this.props.aspect ? {
                unit: "%",
                aspect: this.props.aspect,
                width: this.props.initialWidth
            } : undefined,
            imageCropped: undefined,
        }
    }

    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop) => {
        this.setState({crop});
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                "newFile.jpeg"
            );
            this.setState({croppedImageUrl});
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                this.setState({imageCropped: new File([blob], "newFile.jpeg", {type: "image/jpeg"})})
                resolve(this.fileUrl);
            }, "image/jpeg");
        });
    }


    uploadImage(e) {
        if (e.target.files && e.target.files.length > 0) {
            let imageFile = e.target.files[0];
            if (!this.props.ignoreType)
                if (!(imageFile.type.toLowerCase().includes("jpeg") ||
                    imageFile.type.toLowerCase().includes("jpg") ||
                    imageFile.type.toLowerCase().includes("png"))
                ) {
                    error("File format must be jpeg, jpg or png")
                    return
                }

            const reader = new FileReader();
            reader.addEventListener("load", () => {

                    this.setState({src: reader.result})
                    if (!this.props.withCrop) {
                        if (this.props.onComplete) {
                            this.props.onComplete(imageFile)
                        }
                    } else {
                        this.setState({cropModalShow: true})
                    }
                }
            );
            reader.readAsDataURL(imageFile);
        }
    }

    toDataURL = (url, callback) => {
        let xhr = new XMLHttpRequest();
        xhr.onload = function () {
            let reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    accept() {
        if (this.props.onComplete) {
            this.props.onComplete(this.state.imageCropped)
            this.setState({cropModalShow: false})
        }
    }

    render() {
        return (
            <div className={this.props.className}>

                <input className="upload-image" id={this.props.id}
                       type="file"
                       onChange={this.uploadImage.bind(this)}/>
                <label htmlFor={this.props.id}>
                    {this.props.children}
                </label>
                <Modal
                    show={this.state.cropModalShow}
                    onHide={() => {
                    }}
                    centered={true}
                    size={"lg"}
                >
                    <div className="crop-modal">
                        <button onClick={() => this.setState({cropModalShow: false})}>
                            <i className="icon-remove"/>
                        </button>
                        {this.state.src && (
                            <ReactCrop
                                src={this.state.src}
                                crop={this.state.crop}
                                onImageLoaded={this.onImageLoaded}
                                onComplete={this.onCropComplete}
                                onChange={this.onCropChange}
                            />
                        )}

                    </div>
                    <div className="confirm-crop-image">
                        <div className="accept">
                            <button
                                onClick={this.accept.bind(this)}>Confirm
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default UploadImage
